module.exports = __webpack_public_path__ + "static/media/mastercard.4e9a8cc5.png";